<template>
	<div class="wrapper">
		<div class="contentContainer">
			<div class="contentContainer--body py-2">
				<slot> </slot>
			</div>
			<div class="contentContainer--footer">
				<Footer />
			</div>
		</div>
	</div>
</template>
<script>
import Footer from '@/components/shared/Footer/Footer.vue';
const globalMapper = createNamespacedHelpers('global');
import { createNamespacedHelpers } from 'vuex';

export default {
	components: {
		Footer,
	},
	data() {
		return {
			myCallbacks: {
				onSkip: () => {
					this.isChangeStat = true;
				},
				onFinish: () => {
					this.isChangeStat = true;
				},
			},
			isChangeStat: true,
			height: document.documentElement.clientHeight,
			width: document.documentElement.clientWidth,
		};
	},
	mounted() {
		this.setIndicator('showDetector');
		this.SET_NAME_PAGE('expressdetectorAppName');
	},
	computed: {
		steps() {
			return [
				{
					target: '.v-step-0',
					header: {
						title: `${this.$t('title_step0')}`,
					},
					content: `${this.$t('content_step0')}`,
					before: (type) =>
						new Promise((resolve, reject) => {
							if (window.location.hash === '#/camera') {
								this.$router.push('/home');
							}

							resolve('foo');
						}),
				},
				{
					target: '.v-step-1',
					header: {
						title: `${this.$t('title_step1')}`,
					},
					content: `${this.$t('content_step1')}`,
					params: {
						placement: 'left',
					},
					before: (type) =>
						new Promise((resolve, reject) => {
							this.$router.push('/camera');
							resolve('foo');
						}),
				},
				{
					target: '.v-step-2',
					header: {
						title: `${this.$t('title_step1')}`,
					},
					content: `${this.$t('content_step2')}`,
					params: {
						placement: 'left',
					},
				},
				{
					target: '.v-step-3',
					content: `${this.$t('content_step3')}`,
					before: (type) =>
						new Promise((resolve, reject) => {
							this.$bvModal.hide('modal-1');
							resolve('foo');
						}),
				},
				{
					target: '.v-step-4',
					header: {
						title: `${this.$t('title_step4')}`,
					},
					content: `${this.$t('content_step4')}`,
					params: {
						placement: 'bottom',
					},
					before: (type) =>
						new Promise((resolve, reject) => {
							this.$bvModal.show('modal-1');
							resolve('foo');
						}),
				},
				{
					target: '.v-step-5',
					header: {
						title: `${this.$t('title_step5')}`,
					},
					content: `${this.$t('content_step5')}`,
					before: (type) =>
						new Promise((resolve, reject) => {
							this.$bvModal.hide('modal-1');
							resolve('foo');
						}),
				},
				{
					target: '[data-v-step="6"]',
					header: {
						title: `${this.$t('title_step6')}`,
					},
					content: `${this.$t('content_step6')}`,
					before: (type) =>
						new Promise((resolve, reject) => {
							this.$bvModal.hide('modal-1');
							resolve('foo');
						}),
				},
			];
		},
		stepDetector() {
			return [
				{
					target: '.v-step-1',
					header: {
						title: `${this.$t('title_step1')}`,
					},
					content: `${this.$t('content_step1')}`,
					params: {
						placement: 'left',
					},
				},
				{
					target: '.v-step-2',
					header: {
						title: `${this.$t('title_step1')}`,
					},
					content: `${this.$t('content_step2')}`,
					params: {
						placement: 'left',
					},
				},
				{
					target: '.v-step-3',
					content: `${this.$t('content_step3')}`,
					before: (type) =>
						new Promise((resolve, reject) => {
							this.$bvModal.hide('modal-1');
							resolve('foo');
						}),
				},
				{
					target: '.v-step-4',
					header: {
						title: `${this.$t('title_step4')}`,
					},
					content: `${this.$t('content_step4')}`,
					params: {
						placement: 'bottom',
					},
					before: (type) =>
						new Promise((resolve, reject) => {
							this.$bvModal.show('modal-1');
							resolve('foo');
						}),
				},
				{
					target: '.v-step-5',
					header: {
						title: `${this.$t('title_step5')}`,
					},
					content: `${this.$t('content_step5')}`,
					before: (type) =>
						new Promise((resolve, reject) => {
							this.$bvModal.hide('modal-1');
							resolve('foo');
						}),
				},
				{
					target: '[data-v-step="6"]',
					header: {
						title: `${this.$t('title_step6')}`,
					},
					content: `${this.$t('content_step6')}`,
					before: (type) =>
						new Promise((resolve, reject) => {
							this.$bvModal.hide('modal-1');
							resolve('foo');
						}),
				},
			];
		},

		myOptions() {
			return {
				useKeyboardNavigation: false,
				highlight: true,
				labels: {
					buttonSkip: `${this.$t('Skip')}`,
					buttonPrevious: `${this.$t('Previous')}`,
					buttonNext: `${this.$t('Next')}`,
					buttonStop: `${this.$t('Stop')}`,
				},
			};
		},
	},
	methods: {
		...globalMapper.mapActions(['setIndicator']),
		...globalMapper.mapMutations(['SET_NAME_PAGE']),

		onStartTour() {
			if (window.location.hash === '#/camera') {
				this.$tours['detectorTour'].start();
			} else {
				this.isChangeStat = false;
				this.$tours['myTour'].start();
			}
		},
	},
};
</script>
